var map = {
	"./AD.svg": "25d2",
	"./AE.svg": "03a9",
	"./AF.svg": "6ca9",
	"./AG.svg": "501d",
	"./AI.svg": "d4a7",
	"./AL.svg": "8f1c",
	"./AM.svg": "431c",
	"./AO.svg": "d639",
	"./AQ.svg": "aecb",
	"./AR.svg": "2571",
	"./AS.svg": "958e",
	"./AT.svg": "ea06",
	"./AU.svg": "13c5",
	"./AW.svg": "6f58",
	"./AX.svg": "c8f0",
	"./AZ.svg": "8ffc",
	"./BA.svg": "780d",
	"./BB.svg": "7b78",
	"./BD.svg": "b1cf",
	"./BE.svg": "0dd0",
	"./BF.svg": "4f59",
	"./BG.svg": "6ede",
	"./BH.svg": "a3ec",
	"./BI.svg": "ece8",
	"./BJ.svg": "90df",
	"./BL.svg": "05f1",
	"./BM.svg": "4d02",
	"./BN.svg": "2bff",
	"./BO.svg": "4d83",
	"./BQ.svg": "ae5a",
	"./BR.svg": "35db",
	"./BS.svg": "7541",
	"./BT.svg": "c25a",
	"./BV.svg": "2826",
	"./BW.svg": "bd4c",
	"./BY.svg": "3ad1",
	"./BZ.svg": "648b",
	"./CA.svg": "f6c7",
	"./CC.svg": "22b7",
	"./CD.svg": "b2af",
	"./CF.svg": "dc4b",
	"./CG.svg": "76b3",
	"./CH.svg": "e5e5",
	"./CI.svg": "6342",
	"./CK.svg": "9e0a",
	"./CL.svg": "cac6",
	"./CM.svg": "a975",
	"./CN.svg": "93eb",
	"./CO.svg": "4567",
	"./CR.svg": "75c6",
	"./CU.svg": "761e",
	"./CV.svg": "e5e7",
	"./CW.svg": "eff3",
	"./CX.svg": "d8be",
	"./CY.svg": "134d",
	"./CZ.svg": "c1d6",
	"./DE.svg": "7379",
	"./DJ.svg": "2158",
	"./DK.svg": "0a73",
	"./DM.svg": "8f9c",
	"./DO.svg": "0035",
	"./DZ.svg": "701e",
	"./EC.svg": "9e27",
	"./EE.svg": "f749",
	"./EG.svg": "a091",
	"./EH.svg": "1f62",
	"./ER.svg": "1359",
	"./ES.svg": "3bed",
	"./ET.svg": "392d",
	"./EU.svg": "466a",
	"./FI.svg": "5162",
	"./FJ.svg": "405b",
	"./FK.svg": "ae4a",
	"./FM.svg": "f8f7",
	"./FO.svg": "1216",
	"./FR.svg": "dd7d",
	"./GA.svg": "5890",
	"./GB-ENG.svg": "f84d",
	"./GB-NIR.svg": "ca32",
	"./GB-SCT.svg": "8815",
	"./GB-WLS.svg": "11696",
	"./GB.svg": "71e9",
	"./GD.svg": "c405",
	"./GE.svg": "8cf2",
	"./GF.svg": "f000",
	"./GG.svg": "8777",
	"./GH.svg": "854d",
	"./GI.svg": "445f",
	"./GL.svg": "2065",
	"./GM.svg": "afd0",
	"./GN.svg": "5e8e",
	"./GP.svg": "a64b",
	"./GQ.svg": "e14b",
	"./GR.svg": "347a",
	"./GS.svg": "f3b4",
	"./GT.svg": "8327",
	"./GU.svg": "d8bd",
	"./GW.svg": "9292",
	"./GY.svg": "adad",
	"./HK.svg": "3daa",
	"./HM.svg": "aee7",
	"./HN.svg": "097b",
	"./HR.svg": "c633",
	"./HT.svg": "b150",
	"./HU.svg": "607a",
	"./ID.svg": "042a",
	"./IE.svg": "bd4c0",
	"./IL.svg": "e200",
	"./IM.svg": "0075",
	"./IN.svg": "1fc4",
	"./IO.svg": "8307",
	"./IQ.svg": "9708",
	"./IR.svg": "6560",
	"./IS.svg": "b9bc",
	"./IT.svg": "b7c9",
	"./JE.svg": "1795",
	"./JM.svg": "efed",
	"./JO.svg": "619b",
	"./JP.svg": "508b",
	"./KE.svg": "ed45",
	"./KG.svg": "17ec",
	"./KH.svg": "7607",
	"./KI.svg": "1b4e",
	"./KM.svg": "b237",
	"./KN.svg": "5532",
	"./KP.svg": "f141",
	"./KR.svg": "2f0a",
	"./KW.svg": "d921",
	"./KY.svg": "5e83",
	"./KZ.svg": "102a",
	"./LA.svg": "72f4",
	"./LB.svg": "4857",
	"./LC.svg": "4119",
	"./LI.svg": "74a5",
	"./LK.svg": "4423",
	"./LR.svg": "fd74",
	"./LS.svg": "67d2",
	"./LT.svg": "6511",
	"./LU.svg": "6130",
	"./LV.svg": "7eea",
	"./LY.svg": "13ca",
	"./MA.svg": "b7b5",
	"./MC.svg": "df57",
	"./MD.svg": "1934",
	"./ME.svg": "1a58",
	"./MF.svg": "c733",
	"./MG.svg": "f671",
	"./MH.svg": "462f",
	"./MK.svg": "962e",
	"./ML.svg": "a772",
	"./MM.svg": "7299",
	"./MN.svg": "4c09",
	"./MO.svg": "af9e",
	"./MP.svg": "70ed",
	"./MQ.svg": "9e8b",
	"./MR.svg": "cd17",
	"./MS.svg": "07e9",
	"./MT.svg": "71166",
	"./MU.svg": "1973",
	"./MV.svg": "f439",
	"./MW.svg": "9278",
	"./MX.svg": "3874",
	"./MY.svg": "9c2b",
	"./MZ.svg": "0443",
	"./NA.svg": "c023",
	"./NC.svg": "dd62",
	"./NE.svg": "08c2",
	"./NF.svg": "1541",
	"./NG.svg": "735a",
	"./NI.svg": "675e",
	"./NL.svg": "a8d9",
	"./NO.svg": "f1c2",
	"./NP.svg": "0bd0",
	"./NR.svg": "8ea5",
	"./NU.svg": "dca6",
	"./NZ.svg": "19edb",
	"./OM.svg": "cbfe",
	"./PA.svg": "e46d",
	"./PE.svg": "1183",
	"./PF.svg": "d460",
	"./PG.svg": "ad89",
	"./PH.svg": "8d3d",
	"./PK.svg": "b5c2",
	"./PL.svg": "acce",
	"./PM.svg": "2e02",
	"./PN.svg": "0bea",
	"./PR.svg": "7557",
	"./PS.svg": "5ef5",
	"./PT.svg": "c2c0",
	"./PW.svg": "5a43e",
	"./PY.svg": "6cf6",
	"./QA.svg": "a076",
	"./RE.svg": "b7df",
	"./RO.svg": "3214",
	"./RS.svg": "1e9a",
	"./RU.svg": "46d8",
	"./RW.svg": "239e",
	"./SA.svg": "aeeb",
	"./SB.svg": "bd48",
	"./SC.svg": "56a3",
	"./SD.svg": "c3f2",
	"./SE.svg": "979d",
	"./SG.svg": "43b1",
	"./SH.svg": "951a",
	"./SI.svg": "4599",
	"./SJ.svg": "8ce4",
	"./SK.svg": "65e6",
	"./SL.svg": "ae73",
	"./SM.svg": "c3c4",
	"./SN.svg": "b362",
	"./SO.svg": "b51f",
	"./SR.svg": "a918",
	"./SS.svg": "033a",
	"./ST.svg": "1fd2",
	"./SV.svg": "cb1f",
	"./SX.svg": "86c9",
	"./SY.svg": "4819",
	"./SZ.svg": "f35b",
	"./TC.svg": "6359",
	"./TD.svg": "982f",
	"./TF.svg": "b6b1",
	"./TG.svg": "6930",
	"./TH.svg": "9137",
	"./TJ.svg": "89e6",
	"./TK.svg": "7f4b",
	"./TL.svg": "fbd6",
	"./TM.svg": "8e54",
	"./TN.svg": "5aee",
	"./TO.svg": "586d",
	"./TR.svg": "6f70",
	"./TT.svg": "0572",
	"./TV.svg": "b9b8",
	"./TW.svg": "99f0",
	"./TZ.svg": "94fc",
	"./UA.svg": "ef4e",
	"./UG.svg": "5776",
	"./UM.svg": "2224",
	"./US.svg": "977e",
	"./UY.svg": "043c",
	"./UZ.svg": "7f95",
	"./VA.svg": "b614",
	"./VC.svg": "b51e",
	"./VE.svg": "97ce",
	"./VG.svg": "161a",
	"./VI.svg": "19b3",
	"./VN.svg": "a589",
	"./VU.svg": "02ea",
	"./WF.svg": "2e46",
	"./WS.svg": "53f5",
	"./XK.svg": "c30c",
	"./YE.svg": "aefd",
	"./YT.svg": "59c8",
	"./ZA.svg": "9802",
	"./ZM.svg": "e558",
	"./ZW.svg": "2381"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "427f";